export {default} from 'views/Transactions/Transactions'


// WEBPACK FOOTER //
// ./src/views/Administration/Transactions.jsx